
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 626.6 750"}},[_c('path',{attrs:{"d":"M124.27 227.2c-5 2.7-4.5 11.4.7 13.2 20.2 6.7 37.6 16.5 154.71 18.2 0 0 31.5 1.3 58.39 7.7 0 0-255.6 65.2-335 101.5-4.09 1.9-4.09 8.8 0 10.7 79.41 36.8 335 103.1 335 103.1-26.89 6.5-58.39 7.8-58.39 7.8-117.61 1.7-134.9 11.8-154.9 18.5-5.2 1.8-5.7 10.4-.7 13.2C457.57 704.8 566.47 590 566.47 590V432.3s9.6 41.9-226-57.2c235.5-99.2 226-57.2 226-57.2V159.4c-.09 0-108.9-113-442.2 67.8z","fill":"currentColor"}})])
      }
    
      }
    